import React from 'react'
import { connect } from 'react-redux'
import { TrainingPackageCreateEditForm } from 'containers'
import { trainingPackages } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import PropTypes from 'prop-types'
import { TRAINING_PACKAGES_ROUTE } from 'constants/routes'

const TrainingPackageCreateContainer = ({
  history,
  match,
  location: { fromUrl, fromPathname = 'Training Packages' },
  availableDrills,
  createTrainingPackage,
}) => {
  const linkBack =
    fromUrl || createSubUrl(match, TRAINING_PACKAGES_ROUTE)

  const goBack = () => history.push(linkBack)

  const handleSubmit = ({
    number_of_players: numberOfPlayers,
    images,
    ...values
  }) => {
    const data = {
      ...values,
      number_of_players: +numberOfPlayers,
    }

    if (images && images.length) {
      images.forEach((image, index) => {
        data[`images[${index}]`] = image
      })
    }

    createTrainingPackage(data).then(goBack)
  }

  return (
    <TrainingPackageCreateEditForm
      form="trainingPackageCreate"
      initialValues={{
        global: 0,
        age_class: [],
        number_of_players: 1,
      }}
      caption="Create Training Package"
      fromPath={{
        value: linkBack,
        title: fromPathname,
      }}
      onSubmit={handleSubmit}
      availableDrills={availableDrills}
    />
  )
}

TrainingPackageCreateContainer.defaultProps = {
  availableDrills: [],
}

TrainingPackageCreateContainer.propTypes = {
  history:  PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  match: PropTypes.shape({
      params: PropTypes.shape().isRequired,
    }).isRequired,
  location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      fromUrl: PropTypes.string,
      fromPathname: PropTypes.string,
    }).isRequired,
  availableDrills: PropTypes.arrayOf(PropTypes.object.isRequired),
  createTrainingPackage: PropTypes.func.isRequired,
}

export default connect(({ drills }) => ({ availableDrills: drills.items }), {
  createTrainingPackage: trainingPackages.createTrainingPackage,
})(TrainingPackageCreateContainer)
